import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { ErrorMessage, Input } from "@nju/form";
import { portalRoutes } from "@nju/routes";
import { Button, Separator } from "@nju/ui";
import { getFromQuery } from "@nju/utils";
import { resetPasswordMachine } from "./resetPassword.machine";

export function ResetPasswordForm() {
  const router = useRouter();
  const queryEmailParameter = getFromQuery("email", router.query);

  const [{ context, matches }, send] = useMachine(resetPasswordMachine, {
    actions: {
      onSubmit: () => {
        router.push(portalRoutes.zmianaHasla.potwierdzenie.get());
      },
    },
    context: {
      email: queryEmailParameter,
    },
  });

  const handleSubmit: React.FormEventHandler<HTMLFormElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();
        send({ type: "SUBMIT" });
      },
      [send],
    );

  const handleEmailChange: React.ChangeEventHandler<HTMLInputElement> =
    React.useCallback(
      ({ target }) => {
        send({ type: "SET_EMAIL", name: "email", value: target.value });
      },
      [send],
    );

  return (
    <form
      autoComplete="false"
      className="mt-4 from-tablet:mt-5 from-tablet:flex from-tablet:flex-col"
      onSubmit={handleSubmit}
    >
      <div className="relative mb-12 from-tablet:mb-8">
        <Input
          autoFocus={true}
          label="e-mail"
          name="email"
          onChange={handleEmailChange}
          value={context.email}
        />
        <Separator size="xxs" tone="invisible" />
        {context.emailError && <ErrorMessage message={context.emailError} />}
        {context.formError && <ErrorMessage message={context.formError} />}
      </div>
      <Separator size="m" />
      <div className="flex flex-col from-tablet:justify-between from-tablet:flex-row-reverse">
        <Button isLoading={!matches("ready")} type="submit">
          dalej
        </Button>
        <div className="h-4 w-full from-tablet:hidden" />
        <Button onPress={router.back} variant="secondary">
          powrót
        </Button>
      </div>
    </form>
  );
}
